/**
 * Filtro para poner la primera letra de la frase en mayúsuculas, o de cada palabra, etc.
 * Fuente: https://github.com/Puigcerber/angular-capitalize-filter
 * @returns {Function}
 */
export default function LowerCaseFilter() {
    return function (input) {
        return input.toLowerCase();
    };
}